export default [

     {
          path: '/service',
          name: 'Service',
          component: () => import("@/views/Page/Service/Service.vue"),
          meta: {
               title: 'Services',
          },
     }
];